/**
 * Main Layout with Modern Sidebar
 */

import { SidebarProvider, SidebarInset } from "./ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppNavbar } from "./AppNavbar";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <SidebarInset>
          <AppNavbar />
          <main className="flex-1 overflow-auto p-6 gradient-warm">
            {children}
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
